/**
 * Tiny pub/sub used to surface session events from module-level code (the
 * api middleware in `api.ts`, the `authFetch` wrapper) to the React tree
 * (the `<Toaster>` listener that shows the "Session expired" toast).
 *
 * Decoupled from React on purpose so it can be called from inside a fetch
 * interceptor where hooks aren't available.
 */

export type SessionEvent = "expired";

type Listener = (event: SessionEvent, message?: string) => void;

const listeners = new Set<Listener>();

export const sessionBus = {
  emit(event: SessionEvent, message?: string) {
    for (const l of listeners) l(event, message);
  },
  subscribe(l: Listener): () => void {
    listeners.add(l);
    return () => {
      listeners.delete(l);
    };
  },
};
